<emoji-mart title="Pick your emoji…" (emojiSelect)="addEmoji($event)" [hideObsolete]="true"
[showSingleCategory]="true" [showPreview]="false"></emoji-mart>

<!-- <ngx-emoji emoji=":santa:" [size]="20"></ngx-emoji> -->
